module.exports = __webpack_public_path__ + "static/img/banner.2c81dd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_4/banner.jpg
// module id = 0mvb
// module chunks = 0